



import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class Badge extends Vue {

  @Prop() value: any;
  @Prop() list: string;
  @Prop({default:null}) styles:string[];
  
  public get variant(): string {
    const items = this.$api.formatter.getOptions(this.list);

    const index = items.findIndex(obj => obj.value == this.value);

    if (this.styles == null) {
        switch (index) {
        case 0: return 'badge-primary';
        case 1: return 'badge-secondary';
        case 2: return 'badge-success';
        case 3: return 'badge-danger';
        case 4: return 'badge-warning';
        case 5: return 'badge-info';
        case 6: return 'badge-light';
        default: return 'badge-dark';
      }
    } else {
        return this.styles[index % this.styles.length];
    }

  }
}
